import React from 'react';
import { Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import * as columnFormatters from '../checker-table/column-formatters';

export function CheckerRequestDialogList( {  checker } ) {

	const columns = [
		{
			dataField: 'counter_name',
			text: 'Nama Konter',
		},
		{
			dataField: 'trx_item',
			text: 'Banyak Transaksi',
		},
		{
			dataField: 'trx_total',
			text: 'Jumlah',
			formatter: columnFormatters.PriceColumnFormatter,
		},
	];

	return (
		<Modal.Body className="overlay overlay-block cursor-default">
			<BootstrapTable
				wrapperClasses="table-responsive"
				classes="table table-head-custom table-vertical-center overflow-hidden"
				bootstrap4
				bordered={ false }
				remote
				keyField="settle_batch_uuid"
				data={ checker === null ? [] : checker }
				columns={ columns }
			>
			</BootstrapTable>
		</Modal.Body>
	);
};
